// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 15H15.4141L12 18.4141L8.58594 15H2V2H22V15ZM6 8V10H18V8H6Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 20V22H2V20H22Z"}}]};

const AbstractFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'abstract-filled',
    ref,
    icon: element,
  },
));

AbstractFilledIcon.displayName = 'AbstractFilledIcon';

export default AbstractFilledIcon;
